import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFAB() {
  return (
    <a
      href="https://wa.me/0"
      target="_blank"
      rel="noopener noreferrer"
      className="fab"
      onClick={(e) => e.preventDefault()}
      data-testid="whatsapp-fab"
    >
      <MessageCircle size={20} /> ¿Dudas?
    </a>
  );
}
